import { getAugmentedNamespace } from './_commonjsHelpers.js';
import * as index from '../node_modules/date-fns/esm/toDate/index.js';

var require$$56 = /*@__PURE__*/getAugmentedNamespace(index);

export { require$$56 as default };
